import AdminNavbar from "components/Layout/Navbars/AdminNavbar.js";
import Sidebar from "components/Layout/Sidebar";
import { useRef, useState } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { useSelector } from "react-redux";
import NextLogo from "../../src/assets/img/Mpink.png";
import { getFilteredRoutes } from "utils/getFilteredRoutes";
import routes from "../routes/index";

const SuperAdminLayout = (props) => {
  const mainContent = useRef(null);
  const { user } = useSelector((state) => state.auth);

  const [hide, setHide] = useState(false);

  const filteredRoutes = getFilteredRoutes({ routes, user });

  return (
    <>
      <Sidebar
        {...props}
        routes={routes}
        logo={{
          innerLink: "/super-admin/index",
          imgSrc: NextLogo,
          imgAlt: "logo",
        }}
        hide={hide}
        setHide={setHide}
      />
      <div ref={mainContent} className="main-content pb-4">
        <AdminNavbar {...props} hide={hide} setHide={setHide} />
        <Switch>
          {filteredRoutes.map((route, key) => (
            <Route key={key} path={route.path} component={route.component} />
          ))}

          <Redirect
            to={
              filteredRoutes?.length > 0
                ? filteredRoutes[0]?.path
                : "/super-admin/index"
            }
          />
        </Switch>
      </div>
    </>
  );
};

export default SuperAdminLayout;
